import { apiInstance } from "shared/api";
import { RegisterDeviceBody } from "./types";

export const registerDevice = (body: RegisterDeviceBody): Promise<void> => {
  return apiInstance.post("/v1/me/devices", body).then(() => undefined);
};
